var _g, _rect, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworks1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1037_1304)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32,
    stroke: "#F58634"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1037_1304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1037_1304)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 33.3747C33.6456 33.3747 32.4944 32.9007 31.5463 31.9526C30.5982 31.0045 30.1242 29.8533 30.1242 28.4989C30.1242 27.1445 30.5982 25.9932 31.5463 25.0451C32.4944 24.0971 33.6456 23.623 35 23.623C36.3544 23.623 37.5056 24.0971 38.4537 25.0451C39.4018 25.9932 39.8758 27.1445 39.8758 28.4989C39.8758 29.8533 39.4018 31.0045 38.4537 31.9526C37.5056 32.9007 36.3544 33.3747 35 33.3747ZM35 30.1242C35.4605 30.1242 35.8465 29.9684 36.158 29.6569C36.4695 29.3454 36.6253 28.9594 36.6253 28.4989C36.6253 28.0384 36.4695 27.6524 36.158 27.3409C35.8465 27.0293 35.4605 26.8736 35 26.8736C34.5395 26.8736 34.1535 27.0293 33.842 27.3409C33.5305 27.6524 33.3747 28.0384 33.3747 28.4989C33.3747 28.9594 33.5305 29.3454 33.842 29.6569C34.1535 29.9684 34.5395 30.1242 35 30.1242ZM25.2483 43.1264V40.0384C25.2483 39.4695 25.3905 38.9345 25.6749 38.4334C25.9594 37.9323 26.3454 37.5327 26.833 37.2348C28.0519 36.5305 29.3386 35.9819 30.693 35.5892C32.0474 35.1964 33.4831 35 35 35C36.5169 35 37.9526 35.1964 39.307 35.5892C40.6614 35.9819 41.9481 36.5305 43.167 37.2348C43.6546 37.5327 44.0406 37.9323 44.3251 38.4334C44.6095 38.9345 44.7517 39.4695 44.7517 40.0384V43.1264H25.2483ZM35 38.2506C33.8894 38.2506 32.8059 38.386 31.7494 38.6569C30.693 38.9278 29.6907 39.3341 28.7427 39.8758H41.2573C40.3093 39.3341 39.307 38.9278 38.2506 38.6569C37.1941 38.386 36.1106 38.2506 35 38.2506ZM49.9932 28.7427C49.1535 26.7652 47.9819 25.0248 46.4786 23.5214C44.9752 22.0181 43.2348 20.8465 41.2573 20.0068L42.5169 17C44.9007 17.9752 46.9932 19.3702 48.7946 21.1851C50.5959 23 51.9977 25.0993 53 27.4831L49.9932 28.7427ZM20.0068 28.7427L17 27.4831C18.0023 25.0993 19.4041 23.0068 21.2054 21.2054C23.0068 19.4041 25.0993 18.0023 27.4831 17L28.7427 20.0068C26.7652 20.8465 25.0248 22.0181 23.5214 23.5214C22.0181 25.0248 20.8465 26.7652 20.0068 28.7427ZM27.4831 53C25.0993 52.0248 23.0068 50.6298 21.2054 48.8149C19.4041 47 18.0023 44.9007 17 42.5169L20.0068 41.2573C20.8465 43.2348 22.0181 44.9752 23.5214 46.4786C25.0248 47.9819 26.7652 49.1535 28.7427 49.9932L27.4831 53ZM42.5169 53L41.2573 49.9932C43.2348 49.1535 44.9752 47.9819 46.4786 46.4786C47.9819 44.9752 49.1535 43.2348 49.9932 41.2573L53 42.5169C52.0248 44.9007 50.6298 46.9932 48.8149 48.7946C47 50.5959 44.9007 51.9977 42.5169 53Z",
    fill: "#F58634"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1037_1304",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1037_1304"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1037_1304",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks1);
export default __webpack_public_path__ + "static/media/howitworks1.0100823e044638222ad31ed760bc7d9d.svg";
export { ForwardRef as ReactComponent };